var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, cloneElement, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { colors, opacities } from '../../../defaultTheme';
import { handleKeyboardDown, handleOnMouseDown } from './helpers';
const StyledDropdown = styled.div `
  position: ${({ containerPosition }) => containerPosition || ''};
`;
const DropdownList = styled.ul `
  border-radius: 3px;
  background-color: ${colors.white};
  padding-left: 0;
  box-shadow: 0 4px 5px 0 ${opacities.rgbaLight10},
    0 3px 14px 3px ${opacities.rgbaLight08},
    0 8px 10px 1px ${opacities.rgbaLight04};
  position: absolute;
  left: 0;
  margin: 0;
  z-index: 1;
`;
const DropdownListItem = styled.li `
  color: ${colors.black};
  list-style: none;

  &:first-of-type {
    margin-top: 0;
  }
`;
const DropdownMenu = (_a) => {
    var { children, trigger, containerPosition, className, isDisclosureWidget } = _a, props = __rest(_a, ["children", "trigger", "containerPosition", "className", "isDisclosureWidget"]);
    // eslint-disable-next-line
    const childrenArr = Children.toArray(children);
    const wrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const listRefs = [];
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const activeChildRef = useRef(null);
    for (let i = 0; i < childrenArr.length; i += 1) {
        listRefs.push(React.createRef());
    }
    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setSelectedIndex(-1);
    };
    const onMouseDown = (event) => {
        handleOnMouseDown(event, wrapperRef, setIsOpen);
    };
    useEffect(() => {
        document.addEventListener('mousedown', onMouseDown);
        return () => {
            document.removeEventListener('mousedown', onMouseDown);
        };
    }, []);
    useEffect(() => {
        if (selectedIndex < 0 || selectedIndex > childrenArr.length - 1)
            return;
        const activeRef = listRefs[selectedIndex];
        activeRef.current.focus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIndex]);
    return (_jsxs(StyledDropdown, Object.assign({ containerPosition: containerPosition, className: className }, props, { ref: isOpen ? wrapperRef : null, onKeyDown: (event) => handleKeyboardDown(event, isOpen, selectedIndex, childrenArr, setSelectedIndex, activeChildRef, toggleMenu) }, { children: [cloneElement(trigger, {
                toggleMenu,
                isOpen
            }), isOpen && (_jsx(DropdownList, Object.assign({}, (!isDisclosureWidget && { role: 'menubar' }), { children: childrenArr.map((element, index) => {
                    return (_jsx(DropdownListItem, Object.assign({}, (!isDisclosureWidget && { role: 'menuitem' }), { ref: listRefs[index] }, { children: cloneElement(element, {
                            ref: selectedIndex === index ? activeChildRef : null
                        }) }), `dropdown-item-${index + 1}`));
                }) })))] })));
};
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map